
import { SVGProps } from 'react';

export default function CheckboxSelected(props: Partial<SVGProps<any>>) {
  return (
<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<g filter="url(#filter0_d_4235_121002)">
<rect x="1" y="0.505859" width="16" height="16" rx="2" className='fill-primary dark:fill-primary'/>
<path fillRule="evenodd" clipRule="evenodd" d="M13.5227 5.48311C13.7424 5.70278 13.7424 6.05894 13.5227 6.27861L8.27275 11.5286C8.05308 11.7483 7.69692 11.7483 7.47725 11.5286L4.85225 8.90361C4.63258 8.68394 4.63258 8.32778 4.85225 8.10811C5.07192 7.88844 5.42808 7.88844 5.64775 8.10811L7.875 10.3354L12.7273 5.48311C12.9469 5.26344 13.3031 5.26344 13.5227 5.48311Z" fill="white"/>
</g>
<defs>
<filter id="filter0_d_4235_121002" x="0" y="0.505859" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4235_121002"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4235_121002" result="shape"/>
</filter>
</defs>
</svg>


  )
}